import { render, staticRenderFns } from "./newComHead.vue?vue&type=template&id=260dbb97&scoped=true&"
import script from "./newComHead.vue?vue&type=script&lang=js&"
export * from "./newComHead.vue?vue&type=script&lang=js&"
import style0 from "./newComHead.vue?vue&type=style&index=0&id=260dbb97&prod&scoped=true&lang=less&"
import style1 from "./newComHead.vue?vue&type=style&index=1&id=260dbb97&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260dbb97",
  null
  
)

export default component.exports